import { baseApi } from '@/store/api/base.api';
import { GeneralReducer } from '@/store/general/generalSlice';
import { persistConfig } from '@/store/Store.persist';
import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { persistReducer, persistStore } from 'redux-persist';

const rootReducer = combineReducers({
	[baseApi.reducerPath]: baseApi.reducer,
	general: GeneralReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ['persist/PERSIST', 'persist/REGISTER'],
			},
		}).concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export const GlobalDispatch = store.dispatch;
export type AppDispatch = typeof GlobalDispatch;

export const persistor = persistStore(store);
